// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__box--bZHRw {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__header--NtvJg {
  display: flex;
  align-items: center;
  gap: 16px;
}
.src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__title--u6m6C {
  flex: 1;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
.src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__table--DtAov {
  display: grid;
  grid-template-columns: auto 1fr 1fr 1fr 1fr 50px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
}
.src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__cell--UPOPD {
  padding: 8px 16px;
  text-align: center;
}
.src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__th--EZCRj {
  padding: 8px 16px;
  text-align: center;
  border-top: thin solid #d9d9d9;
  border-bottom: thin solid #d9d9d9;
  border-right: thin solid #d9d9d9;
  background: #fafafa;
}
.src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__td--ni74T {
  padding: 8px 16px;
  text-align: center;
  border-bottom: thin solid #d9d9d9;
  border-right: thin solid #d9d9d9;
}
.src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__tdButton--Rfwr6 {
  padding: 3px 8px;
  border-bottom: thin solid #d9d9d9;
  border-right: thin solid #d9d9d9;
}
.src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__leftColumn--doc8P {
  border-left: thin solid #d9d9d9;
  text-align: left;
}
.src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__record--gaYAd {
  grid-column: span 4;
}
.src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__empty--n3kIh {
  border-left: thin solid #d9d9d9;
  text-align: left;
  padding: 8px 16px;
  text-align: center;
  border-bottom: thin solid #d9d9d9;
  border-right: thin solid #d9d9d9;
  grid-column: span 6;
  color: #0000004d;
}
/*# sourceMappingURL=EditRoleAccessList.module.css.map */`, "",{"version":3,"sources":["webpack://./EditRoleAccessList.module.less","webpack://./src/business/permissions/EditRoleAccessList/EditRoleAccessList.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;ACCF;ADEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;ACAF;ADEA;EACE,OAAA;EAEA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACDF;ADIA;EACE,aAAA;EACA,gDAAA;EAEA,eAAA;EACA,kBAAA;EACA,gBAAA;ACHF;ADOA;EACE,iBAAA;EACA,kBAAA;ACLF;ADQA;EAJE,iBAAA;EACA,kBAAA;EAKA,8BAAA;EACA,iCAAA;EACA,gCAAA;EACA,mBAAA;ACLF;ADOA;EAXE,iBAAA;EACA,kBAAA;EAYA,iCAAA;EACA,gCAAA;ACJF;ADMA;EACE,gBAAA;EACA,iCAAA;EACA,gCAAA;ACJF;ADMA;EACE,+BAAA;EACA,gBAAA;ACJF;ADMA;EACE,mBAAA;ACJF;ADOA;EAPE,+BAAA;EACA,gBAAA;EAvBA,iBAAA;EACA,kBAAA;EAYA,iCAAA;EACA,gCAAA;EAkBA,mBAAA;EACA,gBAAA;ACDF;AACA,wDAAwD","sourcesContent":[".box {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n.title {\n  flex: 1;\n\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n}\n\n.table {\n  display: grid;\n  grid-template-columns: auto 1fr 1fr 1fr 1fr 50px;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n}\n\n@border: thin solid #d9d9d9;\n.cell {\n  padding: 8px 16px;\n  text-align: center;\n}\n\n.th {\n  .cell();\n  border-top: @border;\n  border-bottom: @border;\n  border-right: @border;\n  background: #fafafa;\n}\n.td {\n  .cell();\n  border-bottom: @border;\n  border-right: @border;\n}\n.tdButton {\n  padding: 3px 8px;\n  border-bottom: @border;\n  border-right: @border;\n}\n.leftColumn {\n  border-left: @border;\n  text-align: left;\n}\n.record {\n  grid-column: span 4;\n}\n\n.empty {\n  .leftColumn();\n  .td();\n  grid-column: span 6;\n  color: #0000004d;\n}\n",".box {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n.title {\n  flex: 1;\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n}\n.table {\n  display: grid;\n  grid-template-columns: auto 1fr 1fr 1fr 1fr 50px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n}\n.cell {\n  padding: 8px 16px;\n  text-align: center;\n}\n.th {\n  padding: 8px 16px;\n  text-align: center;\n  border-top: thin solid #d9d9d9;\n  border-bottom: thin solid #d9d9d9;\n  border-right: thin solid #d9d9d9;\n  background: #fafafa;\n}\n.td {\n  padding: 8px 16px;\n  text-align: center;\n  border-bottom: thin solid #d9d9d9;\n  border-right: thin solid #d9d9d9;\n}\n.tdButton {\n  padding: 3px 8px;\n  border-bottom: thin solid #d9d9d9;\n  border-right: thin solid #d9d9d9;\n}\n.leftColumn {\n  border-left: thin solid #d9d9d9;\n  text-align: left;\n}\n.record {\n  grid-column: span 4;\n}\n.empty {\n  border-left: thin solid #d9d9d9;\n  text-align: left;\n  padding: 8px 16px;\n  text-align: center;\n  border-bottom: thin solid #d9d9d9;\n  border-right: thin solid #d9d9d9;\n  grid-column: span 6;\n  color: #0000004d;\n}\n/*# sourceMappingURL=EditRoleAccessList.module.css.map */"],"sourceRoot":""}]);
// Exports
export var box = `src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__box--bZHRw`;
export var header = `src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__header--NtvJg`;
export var title = `src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__title--u6m6C`;
export var table = `src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__table--DtAov`;
export var cell = `src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__cell--UPOPD`;
export var th = `src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__th--EZCRj`;
export var td = `src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__td--ni74T`;
export var tdButton = `src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__tdButton--Rfwr6`;
export var leftColumn = `src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__leftColumn--doc8P`;
export var record = `src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__record--gaYAd`;
export var empty = `src-business-permissions-EditRoleAccessList-EditRoleAccessList-module__empty--n3kIh`;
export default ___CSS_LOADER_EXPORT___;
